import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V2 } from '@studio/constants/env-variables';
import type { Customer } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V2}/customers/names`,
    response: [] as Customer.Get.CustomerNames[],
    method: HTTP_METHODS.GET,
  },
};
